import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "f152bGsygxJoau77ezzvlv6", "GameUI", undefined);

import { _decorator, Component, Node, Label, v3, UITransform, ParticleSystem, tween } from 'cc';
import { E_EventType, E_GameState, E_MainLayerType } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
import { E_SoundType } from './common/manager/SoundManager';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var GameUI = (_dec = ccclass('GameUI'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Label), _dec7 = property(Node), _dec8 = property(Node), _dec9 = property(Label), _dec10 = property(Label), _dec11 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(GameUI, _Component);

  function GameUI() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_guideLine", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_pgTip", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_pg", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_bar", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_end", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_colliderPreTip", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_winPS", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_score", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_lv", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_base", _descriptor10, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_w_pg", 0);

    return _this;
  }

  var _proto = GameUI.prototype;

  _proto.onLoad = function onLoad() {
    App.GameCtrl.n_guideLine = this.n_guideLine;
    App.GameCtrl.lbl_score = this.lbl_score;
  };

  _proto.start = function start() {
    this._w_pg = this.n_pg.getComponent(UITransform).contentSize.width;
    this.addEventListenr();
  };

  _proto.enter = function enter() {
    this.lbl_end.string = App.DataMgr.mapLen + "m";
    this.n_winPS.active = false;
    this.lbl_lv.string = "LEVEL " + (App.DataMgr.tollgateLv + 1);
  };

  _proto.init = function init() {};

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    /**游戏结束 */
    App.EventMgr.addEventLintener(E_EventType.Game_End, this.handle_gameEnd, this);
    /**游戏重置 */

    App.EventMgr.addEventLintener(E_EventType.Game_Reset, this.handle_gameReset, this);
  };

  _proto.removeEventListener = function removeEventListener() {// App.EventMgr.removeEvent(this);
  };

  _proto.handle_gameBegin = function handle_gameBegin() {};

  _proto.handle_gameReset = function handle_gameReset() {
    this.n_colliderPreTip.children.forEach(function (curTip) {
      App.PoolMgr.returnItem(curTip);
    });
    this.n_pgTip.setPosition(v3(-this._w_pg / 2 + this._w_pg * 0.0001, 0, 0));
  };

  _proto.handle_gameEnd = function handle_gameEnd() {
    var _this2 = this;

    App.GameCtrl.gameState = E_GameState.Over;

    if (App.GameCtrl.isWin) {
      App.SoundMgr.playEffectType(E_SoundType.Flower);
      this.n_winPS.active = true;
      var allPs = this.n_winPS.getComponentsInChildren(ParticleSystem);

      for (var i = 0; i < allPs.length; i++) {
        allPs[i].clear();
        allPs[i].play();
      }

      tween(this.node).delay(2).call(function () {
        _this2.n_winPS.active = false;
      }).start();
    } // App.GameCtrl.isWin = true;


    var dt = App.GameCtrl.isWin ? 1.5 : 0.5;
    this.scheduleOnce(function () {
      _this2.clearTip();

      App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Result);
    }, dt);
  };

  _proto.update = function update(dt) {
    if (App.GameCtrl.gameState == E_GameState.Gaming) {
      App.GameCtrl.t_run += dt;
      this.updatePathPg();
      this.updateColliderPreTip();
    }
  }
  /**更新路径进度 */
  ;

  _proto.updatePathPg = function updatePathPg() {
    var aimPg = App.GameCtrl.ball_game.worldPosition.x / App.DataMgr.mapLen;
    if (aimPg < 0) aimPg = 0.00001;
    if (aimPg > 1) aimPg = 1;
    var w_temp = this._w_pg - 10;
    this.n_pgTip.setPosition(v3(-w_temp / 2 + w_temp * aimPg, 0, 0));
    this.n_bar.getComponent(UITransform).width = w_temp * aimPg;
  }
  /**更新障碍物预警 */
  ;

  _proto.updateColliderPreTip = function updateColliderPreTip() {
    var allColliders = App.MapCtr.colliderArr;
    var x_cur = 0;
    var x_r = App.GameCtrl.cam_game.node.worldPosition.x + App.DataMgr.vSize_game.width / 2; // let cam_game: Camera = App.GameCtrl.cam_game;

    var rect = App.GameCtrl.cam_game.rect;
    var h_show = App.DataMgr.visibleSize.height * rect.height;
    var h_base = App.DataMgr.visibleSize.height - h_show;
    var tipIndex = 0;
    var rateScale = 1;
    var pos_screen = v3(); // let size_canvas: Size = view.getCanvasSize();

    for (var i = 0; i < allColliders.length; i++) {
      x_cur = allColliders[i].worldPosition.x;

      if (x_cur > x_r && x_cur - x_r < 15) {
        // App.GameCtrl.cam_ui.convertToUINode(allColliders[i].worldPosition, this.node, pos_screen);
        // let rate: number = pos_screen.y / size_canvas.height;
        var rate = (allColliders[i].position.y + App.DataMgr.vSize_game.height / 2 + App.GameCtrl.cam_game.node.position.y) / App.DataMgr.vSize_game.height;
        var aimY = rate * h_show + h_base;

        if (aimY > App.DataMgr.hPreTip_minInGameUI) {
          var n_tip = this.n_colliderPreTip.children[i];

          if (!n_tip) {
            n_tip = App.PoolMgr.getItem(E_PoolType.UI_ColliderTip);
            if (!n_tip) break;
            n_tip.parent = this.n_colliderPreTip;
          } // n_tip.worldPosition = v3(this.n_colliderPreTip.worldPosition.x, pos_screen.y + App.DataMgr.visibleSize.height / 2, 0);


          n_tip.worldPosition = v3(this.n_colliderPreTip.worldPosition.x, aimY + this.n_base.worldPosition.y, 0);
          rateScale = 1 - (x_cur - x_r) / 20;
          rateScale = rateScale * 0.5 + 0.5;
          n_tip.scale = v3(rateScale, rateScale, 0);
          tipIndex++;
        }
      }
    }

    for (; tipIndex < this.n_colliderPreTip.children.length; tipIndex++) {
      App.PoolMgr.returnItem(this.n_colliderPreTip.children[tipIndex]);
    }
  }
  /**清除提示 */
  ;

  _proto.clearTip = function clearTip() {
    var tipIndex = 0;

    for (; tipIndex < this.n_colliderPreTip.children.length; tipIndex++) {
      App.PoolMgr.returnItem(this.n_colliderPreTip.children[tipIndex]);
    }
  };

  return GameUI;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_guideLine", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_pgTip", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_pg", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_bar", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "lbl_end", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "n_colliderPreTip", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_winPS", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "lbl_score", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "lbl_lv", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "n_base", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();